/* eslint-disable no-param-reassign */
import React, { useState } from 'react';
import { TextAreaStyled } from './styled';
function Textarea(_a) {
    var minRows = _a.minRows, id = _a.id, name = _a.name, onChange = _a.onChange, value = _a.value, placeholder = _a.placeholder;
    var maxRows = 15;
    var _b = useState(minRows), rows = _b[0], setRows = _b[1];
    var onInputChange = function (event) {
        if (minRows !== undefined) {
            var prevRows = event.target.rows;
            event.target.rows = minRows;
            var currentRows = Math.floor((event.target.scrollHeight - 24) / 24);
            if (currentRows === prevRows) {
                event.target.rows = currentRows;
            }
            if (currentRows >= maxRows) {
                event.target.rows = maxRows;
            }
            setRows(currentRows < maxRows ? currentRows : maxRows);
        }
        onChange(event);
    };
    return (React.createElement(TextAreaStyled, { id: id, "data-testid": id, name: name, onChange: onInputChange, value: value, placeholder: placeholder, rows: minRows !== undefined ? rows : undefined, "$setMax": minRows === undefined, "data-hj-suppress": true }));
}
export default Textarea;
